import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {from, Observable, throwError} from 'rxjs';
import {AuthenticationService} from '../services/authentication.service';
import {mergeMap, retryWhen, take} from "rxjs/operators";
import { UserDataStoreService } from "../services/user-data-store.service";


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _userDataStore: UserDataStoreService, private _authenticationService: AuthenticationService) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!!req.headers.get('Anonymous')) {
      const newHeaders = req.headers.delete('Anonymous')
      const newRequest = req.clone({ headers: newHeaders });
      return from(next.handle(newRequest).toPromise());
    } else {
      return from(this.addBearerToken(req, next));
    }
  }


  private async addBearerToken(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const release = await this._userDataStore.mutex.acquire();
    const headerSettings = req.headers.keys().reduce(
      (acc, cur) => {
        acc[cur] = req.headers.getAll(cur);
        return acc;
      }, {});

    if (this._userDataStore.currentUserValue) {
      const token = this._userDataStore.currentUserValue.token;
      headerSettings['Authorization'] = `Bearer ${token}`;
    }

    // prevent 302 redirect to challenge on a 401
    headerSettings['X-Requested-With'] = 'XMLHttpRequest';
    const headers = new HttpHeaders(headerSettings);
    const newRequest = req.clone({headers});
    const result = next.handle(newRequest).toPromise();

    return (<any>result.catch(async (err) => {
      if (err.status === 401) {
        try {
          const result = await this._authenticationService.refreshSession();
          if (result == true) {
            const newToken = this._userDataStore.currentUserValue.token;
            headerSettings['Authorization'] = `Bearer ${newToken}`;
            headerSettings['X-Requested-With'] = 'XMLHttpRequest';
            const updatedHeaders = new HttpHeaders(headerSettings);
            const updatedRequest = req.clone({ headers: updatedHeaders });
            return next.handle(updatedRequest).toPromise();
          } else {
            this._authenticationService.logout();
            location.reload();
          }
        } finally {
          //console.log('Release (401)');
          release();
        }
      } else {
        throw err;
      }
    }).finally(() => {
      //console.log('Release (200)');
      release();
    }));
  }
}
